(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-video-on-hover-2"] && !Shopify.designMode) return;
  try {
    
  // queries elements in snippets/image-with-video
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[id^="video-placeholder-"]').forEach(function(placeholder) {
    const videoUrl = placeholder.getAttribute('data-video-url');
    
    const videoElement = document.createElement('video');
    videoElement.className = 'circle-video';
    videoElement.muted = true;
    videoElement.autoplay = true;
    videoElement.loop = true;

    const sourceElement = document.createElement('source');
    sourceElement.src = videoUrl;
    sourceElement.type = 'video/mp4';

    videoElement.appendChild(sourceElement);
    placeholder.appendChild(videoElement);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-video-on-hover"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[id^="video-placeholder-"]').forEach(function(placeholder) {
    const videoUrl = placeholder.getAttribute('data-video-url');
    
    const videoElement = document.createElement('video');
    videoElement.className = 'circle-video';
    videoElement.muted = true;
    videoElement.autoplay = true;
    videoElement.loop = true;

    const sourceElement = document.createElement('source');
    sourceElement.src = videoUrl;
    sourceElement.type = 'video/mp4';

    videoElement.appendChild(sourceElement);
    placeholder.appendChild(videoElement);
  });
});

  } catch(e) { console.error(e); }
})();
})();
